import React from 'react';
import { Row, Col } from 'react-bootstrap';
import SkeletonCard from '../../../../components/Skeleton/Card';

const Loading: React.FC<React.PropsWithChildren<unknown>> = () => {
  const height = 76;
  return (
    <>
      <Row>
        <Col>
          <SkeletonCard height={height} />
        </Col>
      </Row>
      <Row>
        <Col>
          <SkeletonCard height={height} />
        </Col>
      </Row>
      <Row>
        <Col>
          <SkeletonCard height={height} />
        </Col>
      </Row>
    </>
  );
};

export default Loading;
